import { useLocation, useNavigate } from "react-router-dom";
import { pathsMap } from "navigation/Paths";
import { Breadcrumbs, Text, UnstyledButton } from "@mantine/core";

function toPath(str: string) {
  return pathsMap[str] ?? "";
}

export const AppBreadCrumbs = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <Breadcrumbs m="sm">
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        console.log(to);
        return last ? (
          <Text key={to} color="dimmed">
            {toPath(value)}
          </Text>
        ) : (
          <UnstyledButton onClick={() => navigate(to)} key={to}>
            <Text>{toPath(value)}</Text>
          </UnstyledButton>
        );
      })}
    </Breadcrumbs>
  );
};
